import settings from "../../../../constants/settings";
import useFetchAndTrace from "../../fetchWithTrace";
import { useCallback, useState } from "react";
import { Response } from "next/dist/compiled/@edge-runtime/primitives";

export default function useChangeBoardOwner(
  orError: () => void,
  onSuccess?: () => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const [changingOwner, setChangingOwner] = useState(false);

  const addUserHandler = useCallback(
    (response: Response) => {
      setChangingOwner(false);
      if (response.ok) {
        onSuccess?.();
      } else {
        throw Error("Failed to add user to board");
      }
    },
    [onSuccess],
  );

  const changeBoardOwner = useCallback(
    (email: string, boardId: string) => {
      setChangingOwner(true);
      void fetchAndTrace(
        `${settings.api_url}/boards/${boardId}/user`,
        addUserHandler,
        orError,
        {
          method: "PUT",
          body: JSON.stringify({
            email,
          }),
        },
      );
    },
    [addUserHandler, fetchAndTrace, orError],
  );

  return { changeBoardOwner, changingOwner };
}
